import React from 'react';
import { getImageUrl } from '../QuestionDataMappers';
import { COLORS } from '../QuestionChartConfig';
import { EMOJI_SETS } from '../../EvaluationScaleConfig';

const ResultsTable = ({ question }) => {
  const total = (question.results || []).reduce((sum, item) => sum + Number(item.value), 0);
  const sortedResults = [...(question.results || [])].sort((a, b) => Number(b.value) - Number(a.value));
  const isOpenQuestion = question.questionType === 'open';
  const isPointsBased = ['points', 'preference_order'].includes(question.responseFormat);

  return (
    <div className="table-responsive border rounded bg-white mt-3 results-table-wrapper">
      <table className="table table-hover mb-0 results-table">
        <thead>
          <tr>
            <th className="font-weight-bold text-uppercase py-2 px-4">{isOpenQuestion ? 'Respuesta' : 'Opción'}</th>
            {!isOpenQuestion && (
              <>
                <th className="font-weight-bold text-uppercase py-2 px-4 text-right th-points-responses">
                  {isPointsBased ? 'Puntos' : 'Respuestas'}
                </th>
                {!isPointsBased && (
                  <th className="font-weight-bold text-uppercase py-2 px-4 text-right th-percentage">%</th>
                )}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {sortedResults.map(item => {
            const pct = total > 0 ? ((Number(item.value) / total) * 100).toFixed(0) : '0';
            const imageUrl = getImageUrl(item);
            const originalIdx = (question.results || []).findIndex(r => r.name === item.name);
            const itemColor = originalIdx !== -1 ? COLORS[originalIdx % COLORS.length] : '#ccc';

            let emoji = null;
            if (question.responseFormat === 'emojis') {
              const sortedChoices = (question.questionChoicesAttributes || [])
                .filter(c => !c._destroy)
                .sort((a, b) => a.position - b.position);
              const n = sortedChoices.length;
              const emojis = EMOJI_SETS[n] || EMOJI_SETS[5];
              const choice = sortedChoices.find(c => {
                const nameStr = c.label || String(c.position);
                return nameStr === item.name;
              });
              const choiceIdx = choice ? sortedChoices.indexOf(choice) : -1;
              emoji = choiceIdx !== -1 ? emojis[choiceIdx] : null;
            }

            return (
              <tr key={item.id || item.name}>
                <td className={`py-2 px-4 text-dark ${isOpenQuestion ? 'font-weight-medium' : 'font-weight-bold'}`}>
                  <div className="d-flex align-items-center">
                    <span className="survey-result-color-dot" style={{ backgroundColor: itemColor }} />
                    {imageUrl && (
                      <>
                        <img src={imageUrl} alt={item.name} className="survey-result-table-img" />
                        <span>{item.name}</span>
                      </>
                    )}
                    {!imageUrl && emoji && (
                      <div className="d-flex align-items-center">
                        <span className="survey-result-emoji-span">{emoji}</span>
                        <span>{item.name}</span>
                      </div>
                    )}
                    {!imageUrl && !emoji && <span>{item.name}</span>}
                  </div>
                </td>
                {!isOpenQuestion && (
                  <>
                    <td className="py-2 px-4 text-right font-weight-bold text-dark">{item.value}</td>
                    {!isPointsBased && <td className="py-2 px-4 text-right font-weight-bold text-dark">{pct}%</td>}
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ResultsTable;
